import localforage from 'localforage'
import { Toast } from 'vant'
/**
 * 校验email
 */
export const isEmail = (value) =>
  /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(value)

/**
 * 校验手机号码
 */
// export const isPhone = (value) => /^1[0-9]{10}$/.test(value)
export const isPhone = (value) => /^1[3456789]\d{9}$/.test(value)

/**
 * 效验姓名（中英文）
 */
export const isName = (value) => /^[\u4e00-\u9fa5a-zA-Z]{1,11}$/.test(value)

/**
 * 获取当前url上的参数
 */
export const getUrlParams = (name) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  const param = window.location.search.substr(1).match(reg)
  return param && param[2]
}

/**
 * 存储localStorage
 */
export const setStore = async (name, content) => {
  if (!name) return
  const BID = getUrlParams('bid')
  try {
    return await localforage.setItem(name, content)
  } catch (error) {
    Toast(error)
  }
}

/**
 * 获取localStorage
 */
export const getStore = async (name) => {
  if (!name) return
  const BID = getUrlParams('bid')
  try {
    return await localforage.getItem(name)
  } catch (error) {
    Toast(error)
  }
}

/**
 * 删除localStorage
 */
export const removeStore = async (name) => {
  if (!name) return
  const BID = getUrlParams('bid')
  try {
    return await localforage.removeItem(name)
  } catch (error) {
    Toast(error)
  }
}

export const timeFormat = (timestr) => {
  if (!timestr) {
    return null
  }
  let arr = timestr.split(' ')
  let yyyyMMdd = arr[0].split('-')
  let HHmmss = arr[1].split(':')

  let d = new Date()
  d.setFullYear(parseInt(yyyyMMdd[0]))
  d.setMonth(parseInt(yyyyMMdd[1]) - 1)
  d.setDate(parseInt(yyyyMMdd[2]))
  d.setHours(parseInt(HHmmss[0]))
  d.setMinutes(parseInt(HHmmss[1]))
  d.setSeconds(parseInt(HHmmss[2]))
  d.setMilliseconds(0)

  let createTime = d.getTime()
  let res
  let now = new Date().getTime()
  let dateDiff = now - createTime
  let dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000))
  let monthDiff = Math.floor(dayDiff / 30)
  let yearDiff = Math.floor(monthDiff / 12)
  let leave1 = dateDiff % (24 * 3600 * 1000)
  let hours = Math.floor(leave1 / (3600 * 1000))
  let leave2 = leave1 % (3600 * 1000)
  let minutes = Math.floor(leave2 / (60 * 1000))
  if (dateDiff / 1000 < 3600 / 60) {
    res = '刚刚'
  } else if (dateDiff / 1000 > 3600 / 60 && dateDiff / 1000 < 3600) {
    res = `${minutes}分钟前`
  } else if (dateDiff / 1000 > 3600 && dateDiff / 1000 < 3600 * 24) {
    res = `${hours}小时前`
  } else if (dateDiff / 1000 > 3600 * 24 && dateDiff / 1000 < 3600 * 24 * 30) {
    res = `${dayDiff}天前`
  } else if (
    dateDiff / 1000 > 3600 * 24 * 30 &&
    dateDiff / 1000 < 3600 * 24 * 30 * 12
  ) {
    res = `${monthDiff}月前`
  } else if (dateDiff / 1000 > 3600 * 24 * 30 * 12) {
    res = `${yearDiff}年前`
  }
  return res
}
